import { render, staticRenderFns } from "./EmailBestaetigung.vue?vue&type=template&id=05ba02e6&"
import script from "./EmailBestaetigung.vue?vue&type=script&lang=js&"
export * from "./EmailBestaetigung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports